module.exports = __webpack_public_path__ + "assets/img/00100.a1c168ee.png";